module.exports = __webpack_public_path__ + "img/663.51d394f5.png";